module.exports = __webpack_public_path__ + "static/media/tipxby.9a52ebe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tipxby.png
// module id = 750
// module chunks = 0